import { Quote } from './quote.model';
import { Component, Injector } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { QuotesService } from './quotes.service';
@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent extends BaseListComponent<Quote> {

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}

  constructor(
    public quotesServ: QuotesService,
    public injector: Injector,
    public auth:AuthService,
  ) {
    super(quotesServ,injector,'quote',{createUrl:'/admin/quotes/new',editUrl:'/admin/quotes/edit'});
   }

  protected tableProprieties(): string[] {
    let columns=[
      'Descrição',
      'Valor',
      'Dia do Pagamento',
      'Periodicidade',
      'Clube',
    ]

    if(this.isManager() || this.isUserClub()) {
      columns.splice(columns.length-1,1)
    }

    return columns;
  }
}
